<script setup lang="ts">
import Button from '~/components/common/Button.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import LockIcon from '~/assets/icons/LockOutline.svg'
import Pill from '~/components/Pill.vue'

type TProps = {
  title: string
  publicationFrequency?: string
  date: string
  isNew: boolean
  image: string
  timeToRead: string
  link: string
  canRead?: boolean
}

defineProps<TProps>()
</script>

<template>
  <div
    class="briefing-card relative flex h-[340px] flex-col justify-end rounded-lg border p-6 text-white"
  >
    <img
      class="absolute inset-0 h-full w-full rounded-lg object-cover mix-blend-multiply filter"
      :src="image"
      alt="img"
    />

    <div class="relative flex h-full flex-col justify-between">
      <div class="flex grow justify-end">
        <Pill v-if="!isNew" class="h-fit"> New </Pill>
      </div>

      <h3 class="text-lg font-bold xl:text-2xl">{{ title }}</h3>

      <div class="mt-1 items-center justify-between xl:mt-3 xl:flex">
        <!-- Desktop CTA -->
        <div class="hidden xl:block">
          <Button
            v-if="canRead"
            class="w-full bg-grey-600 px-4 py-3 text-sm xl:w-auto"
            :link="link"
          >
            Read Now
          </Button>
          <ButtonContactUs v-else class="bg-grey-600 text-sm" />
        </div>

        <div class="flex items-center justify-between">
          <div class="flex w-full items-center justify-between gap-2">
            <div class="text-left xl:text-right">
              <p class="text-xs font-semibold xl:text-h7">
                {{ publicationFrequency }}
                {{ publicationFrequency && '|' }}
                {{ date }}
              </p>
              <p class="mt-1 text-xs font-semibold xl:text-h7">
                {{ timeToRead }} read
              </p>
            </div>
            <LockIcon v-if="!canRead" class="size-7 stroke-p-700 xl:size-11" />
          </div>
        </div>
      </div>

      <!-- Mobile CTA -->
      <div class="xl:hidden">
        <Button
          v-if="canRead"
          class="mt-3 block w-full bg-grey-600 px-4 py-3 text-sm md:w-full"
          :link="link"
        >
          Read Now
        </Button>
        <ButtonContactUs
          v-else
          class="mt-4 w-full bg-grey-600 text-sm md:w-full lg:w-full"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.briefing-card {
  background: linear-gradient(
    180deg,
    rgb(0 0 0 / 0%) 38.67%,
    rgb(0 0 0 / 70%) 63.66%,
    rgb(0 0 0 / 80%) 95.54%
  );
}
</style>
